import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>P.IVA 02216430385</p>
        <p>&copy;{new Date().getFullYear()} Roberto Manderioli. Tutti i diritti riservati.</p>
        <p>Site version 1.3 (30/10/2026)</p>
        <div className="footer-links">
          {/* <a href="/privacy">Privacy</a> */}
          {/* <a href="/terms">Termini</a> */}
          <a href="https://www.facebook.com/profile.php?id=100027510056125/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://www.instagram.com/roberto_manderioli_ph/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
